import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import TextFieldCardCounter from '../../shared/TextFieldCardCounter';
import RowTitle from '../RowTitle';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    input: {
      width: 542,
    },
  },
  {
    name: 'Name',
  },
);

const Name = ({ value, onChange, isSaved, disabled }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { pathKey } = useSelector(store => store.aiBot);

  return (
    <div className={classes.root}>
      <RowTitle title={t(`${pathKey}:basicSettingContainer.name`)} isRequired />
      <TextFieldCardCounter
        className={classes.input}
        placeholder={t(`${pathKey}:basicSettingContainer.namePlaceholder`)}
        maxCount={0}
        value={value}
        onChange={onChange}
        status={isSaved && !value ? 'error' : 'default'}
        isDisable={disabled}
      />
    </div>
  );
};

export default Name;
